import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import FilePreview from 'Common/FilePreview';
import { TitledCard } from 'Components/';

class ImportPreview extends Component {
  static propTypes = {
    fileData: PropTypes.array,
    updatePreviewData: PropTypes.func,
    header: PropTypes.arrayOf(
      PropTypes.shape({
        FieldName: PropTypes.string,
        ColumnNumber: PropTypes.number,
        ColumnLabel: PropTypes.string,
      })
    ),
    notificationSystem: PropTypes.object,
    options: PropTypes.array,
    resizable: PropTypes.bool,
    useSelectPortal: PropTypes.bool,
    onUploadAnotherClick: PropTypes.func,
    onClearMappingClick: PropTypes.func,
    onResetClick: PropTypes.func,
    hasHeaderInfo: PropTypes.bool,
    tableColProps: PropTypes.object,
  };

  static defaultProps = {
    fileData: [],
    header: [],
    updatePreviewData: () => {},
    resizable: false,
    options: [],
    useSelectPortal: false,
    hasHeaderInfo: false,
    headerInfo: {},
    tableColProps: {},
  };

  render() {
    const {
      fileData,
      updatePreviewData,
      header,
      notificationSystem,
      onClearMappingClick,
      onUploadAnotherClick,
      onResetClick,
      options: columnOptions,
      resizable,
      useSelectPortal,
      hasHeaderInfo,
      tableColProps,
    } = this.props;

    let data = fileData;

    let headerInfo = [];

    if (hasHeaderInfo) {
      [headerInfo, ...data] = fileData;
    }

    return (
      <TitledCard title="Import Preview">
        <div className="file-preview--header-wrapper">
          {onResetClick && (
            <Button
              className="file-preview--clear-mapping file-preview--header-button"
              size="tiny"
              onClick={onResetClick}
            >
              Reset
            </Button>
          )}
          {onClearMappingClick && (
            <Button
              className="file-preview--clear-mapping file-preview--header-button"
              size="tiny"
              onClick={onClearMappingClick}
            >
              Clear Mapping
            </Button>
          )}
          {onUploadAnotherClick && (
            <Button
              className="file-preview--upload-new-file file-preview--header-button"
              size="tiny"
              onClick={onUploadAnotherClick}
            >
              Upload Another File
            </Button>
          )}
        </div>
        <FilePreview
          fileData={data}
          updatePreviewData={updatePreviewData}
          header={header}
          notificationSystem={notificationSystem}
          options={columnOptions}
          style={{ marginTop: '-1rem' }}
          resizable={resizable}
          useSelectPortal={useSelectPortal}
          hasHeaderInfo={hasHeaderInfo}
          headerInfo={headerInfo}
          tableColProps={tableColProps}
        />
      </TitledCard>
    );
  }
}

export { ImportPreview };



// WEBPACK FOOTER //
// ./src/common/Components/ImportPreview/ImportPreview.js